import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../../environments/environment';
import { AuthService } from '../../../../../../services/auth.service';
import { ComponentService } from '../../../../../../services/component.service';
import { NewApiHttpService } from '../../../../../../services/new-api-http.service';
import { FilesManagerService } from '../../../../../../services/files-manager.service';
import { tap, map } from 'rxjs/operators';

@Injectable()
export class FileUploadManagerService {
	constructor(
		private comService: ComponentService,
		private http: HttpClient,
		private auth: AuthService,
		private files: FilesManagerService,
		private newApiHttpService: NewApiHttpService
	) {}

	uploadFile(file: File): Observable<any> {
		this.comService.updateDisabledSave(true);

		return this.newApiHttpService.newApiRequestUpload('cms', { file }).pipe(tap(() => this.comService.updateDisabledSave(false)));
	}

	getFileList(start, type, order) {
		const data = { start: start, type: type, order: order };
		return this.newApiHttpService.newApiRequestGet('cms', data);
	}

	importFile(importUrl) {
		return this.newApiHttpService.newApiRequestPost('cms/import', { file: importUrl });
	}

	deleteFile(fileName) {
		return this.newApiHttpService.newApiRequestDelete('cms', { file: fileName });
	}
}
